import React from 'react';
import { Alert, Col } from 'reactstrap';
import { NavLink } from 'react-router-dom';

// `messageLink` hat bewusst keinen Standard: die meisten Hinweise sind reine Information und
// dürfen nicht verlinkt werden. Aufrufer, die einen Link wollen, geben ein absolutes Ziel an —
// ein relatives (`../projekte`) hängt an der aktuellen Route und bricht bei jeder Pfadänderung.
const VotePlaceholder = ({ messageText, text, messageType = 'primary', messageLink, link }) => {
    const displayText = messageText || text;
    const targetLink = messageLink || link;

    const alertMessage = (
        <Alert
            color={messageType}
            className="text-center d-flex align-items-center justify-content-center mb-3"
            style={{ minHeight: '80px' }}
        >
            {displayText}
        </Alert>
    );

    return (
        <Col>
            {targetLink ? (
                <NavLink to={targetLink} className="text-decoration-none">
                    {alertMessage}
                </NavLink>
            ) : (
                alertMessage
            )}
        </Col>
    );
};

export default VotePlaceholder;
